import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";


@Injectable()
export class EfulfillmentService extends EndpointFactory{

    private _baseURL = '';

    constructor(public http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getEFulfillmentDetail(productId): Observable<any> {
        return this.http
            .get(this._baseURL + `api/efulfillment/get-eFulfilment-detail/${productId}`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null)
            })
    }

    getCardTemplateAzure(): Observable<any> {
        var url = "https://lifeportalstorage.blob.core.windows.net/efulfillment/templates/"
        return this.http
            .get(this._baseURL + `api/efulfillment/get-cardTemplate-azure`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null)
            })
    }

    clearTemplateCache(): Observable<any> {
        return this.http
            .post(this._baseURL + `api/efulfillment/clear-template-cache`, null, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null)
            })
    }

    createEditEFulfillment(formData) {
        return this.http
            .post(this._baseURL + `api/efulfillment/create-edit-efulfillment`, formData, this.getRequestHeadersUpload())
            .catch(err => {
                return this.handleError(err, null)
            })
    }

    uploadFilesToAzure( f: any) {

        //var options = this.commonService.getAuthHeader(false);
        //var blob = this.dataURItoBlob(dataURL);
        var fd = new FormData(document.forms[0]);
        fd.append('fileCardTemplate', f, f.name);

        return this.http
            .post(this._baseURL + '/api/efulfillment/upload-file/', fd, this.getRequestHeadersUpload(false))
            .catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/efulfillment.service.ts